export const GROUP_BUDGET = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  VOIDED: 'voided',
};

export const SUBSCRIPTION = {
  ACTIVE: 'active',
  PENDING: 'pending',
  PENDING_CANCEL: 'pending_cancel',
  CANCELLED: 'cancelled',
};

export const REIMBURSEMENT = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING: 'pending',
  RECURRING: 'in_progress',
  COMPLETED: 'completed',
};

export const TRANSACTION = {
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  FULFILLED: 'fulfilled',
  PROCESSING: 'processing',
  PENDING: 'pending',
  SHIPPED: 'shipped',
  REFUNDED: 'refunded',
};

export const CONNECTED_ACCOUNT_STATUSES = {
  ACTIVE: 'active',
  DELETED: 'deleted',
  PENDING_CREATE: 'pendingCreate',
  PENDING_DELETE: 'pendingDelete',
  PENDING_VERIFICATION: 'pendingVerification',
};

export enum PRETAXV2_ACCOUNT_STATUS {
  ACTIVE = 'active',
  TEMPORARILY_INACTIVE = 'temporarily_inactive',
  PERMANENTLY_INACTIVE = 'permanently_inactive',
  TERMINATED = 'terminated',
  ACTIVE__TO_BE_TRANSFERRED = 'active__to_be_transferred',
}

// enum CardPurchaseRequestStatus in card-transactions-service
export enum CardPurchaseStatusAPI {
  APPROVED = 'approved',
  CANCELED = 'canceled',
  DECLINED = 'declined',
  PROCESSING = 'processing',
  REFUDN = 'refund',
}

// enum AdjudicationStatus in card-transactions-service
export enum AdjudicationStatusAPI {
  AWAITING_RECEIPT = 'awaiting_receipt',
  UNDER_REVIEW = 'under_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  REJECTED_PAID = 'rejected_paid',
}

export enum ModifiedAdjudicationStatusAPI {
  AWAITING_RECEIPT = 'awaiting_receipt',
  UNDER_REVIEW = 'under_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  REJECTED_PAID = 'rejected_paid',
  NOT_REQUIRED = 'not_required',
}

export enum AdjudicationStatusClient {
  AWAITING_RECEIPT = 'Receipt required',
  UNDER_REVIEW = 'Receipt under review',
  APPROVED = 'Receipt approved',
  REJECTED = 'Receipt rejected',
  REJECTED_PAID = 'Transaction rejected, but paid',
  NOT_REQUIRED = 'Receipt not required',
}

export const PRETAXV2_TRANSACTION_ADJUDICATION_STATUS_MAP: Record<
  ModifiedAdjudicationStatusAPI,
  AdjudicationStatusClient
> = {
  [ModifiedAdjudicationStatusAPI.AWAITING_RECEIPT]:
    AdjudicationStatusClient.AWAITING_RECEIPT,

  [ModifiedAdjudicationStatusAPI.UNDER_REVIEW]:
    AdjudicationStatusClient.UNDER_REVIEW,

  [ModifiedAdjudicationStatusAPI.APPROVED]: AdjudicationStatusClient.APPROVED,

  [ModifiedAdjudicationStatusAPI.REJECTED]: AdjudicationStatusClient.REJECTED,

  [ModifiedAdjudicationStatusAPI.REJECTED_PAID]:
    AdjudicationStatusClient.REJECTED_PAID,

  [ModifiedAdjudicationStatusAPI.NOT_REQUIRED]:
    AdjudicationStatusClient.NOT_REQUIRED,
};

export enum PRETAX_CARD_TRANSACTONS_RECEIPT_MSG {
  AWAITING_RECEIPT = 'The IRS requires all expenses paid from your pretax accounts to be substantiated, so receipts are often required to validate transactions if it cannot be auto-substantiated. Please upload the receipt so we can verify the eligibility.',
  UNDER_REVIEW = `The receipt you uploaded is being reviewed by our support team. Check your email or come back to this page to see if it’s been approved.`,
  APPROVED = 'Your uploaded receipt has been approved by our support team. No further action is required from you. An email confirmation has been sent to you.',
  REJECTED = 'We’ve found that one or more items on your receipt were ineligible based on IRS rules and you account has incurred a balance due. Please authorize Forma to charge your personal card to recoup the cost or by submitting claims to offset the due amount. If you feel it is an eligible transaction, please send the receipt to support@joinforma.com, and we will take care of you!',
  REJECTED_PAID = 'You have paid back the balance due. No further action needed.',
  NOT_REQUIRED = '',
}

// note: eventually the API will eventually return the message associated with the adjudication status
// thus, removing the need for this map
export const STATUS_MESSAGE_MAP: Record<ModifiedAdjudicationStatusAPI, string> =
  {
    [ModifiedAdjudicationStatusAPI.AWAITING_RECEIPT]:
      PRETAX_CARD_TRANSACTONS_RECEIPT_MSG.AWAITING_RECEIPT,
    [ModifiedAdjudicationStatusAPI.UNDER_REVIEW]:
      PRETAX_CARD_TRANSACTONS_RECEIPT_MSG.UNDER_REVIEW,
    [ModifiedAdjudicationStatusAPI.APPROVED]:
      PRETAX_CARD_TRANSACTONS_RECEIPT_MSG.APPROVED,
    [ModifiedAdjudicationStatusAPI.NOT_REQUIRED]:
      PRETAX_CARD_TRANSACTONS_RECEIPT_MSG.NOT_REQUIRED,
    [ModifiedAdjudicationStatusAPI.REJECTED]:
      PRETAX_CARD_TRANSACTONS_RECEIPT_MSG.REJECTED,
    [ModifiedAdjudicationStatusAPI.REJECTED_PAID]:
      PRETAX_CARD_TRANSACTONS_RECEIPT_MSG.REJECTED_PAID,
  };
